import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DashboardDesignerState, dashboardItemAdapter } from "../reducers/dashboard-designer.reducers";
import * as dashboardDesignerReducers from "../reducers/dashboard-designer.reducers";

export const selectDashboardItemsState = createFeatureSelector<DashboardDesignerState>('dashboardDesigner');

export const {
  selectIds,
  selectEntities,
  selectAll: selectAllDashboardItems,
  selectTotal,
} = dashboardItemAdapter.getSelectors(selectDashboardItemsState);

export const selectById = (id) => createSelector(selectEntities, (entities) => {
  return entities[id] || null;
});


export const selectDesignerMode = createSelector([selectDashboardItemsState],
  (state: dashboardDesignerReducers.DashboardDesignerState) => state.designerMode);

export function selectCurrentDashboard() {
  return createSelector(
    [selectDashboardItemsState],
    (state: dashboardDesignerReducers.DashboardDesignerState) => state.currentDashboard);
}

export function selectCurrentProfile() {
  return createSelector(
    [selectDashboardItemsState],
    (state: dashboardDesignerReducers.DashboardDesignerState) =>state.currentProfile);
}



export function selectLoading() {
  return createSelector(
    [selectDashboardItemsState],
    (state: dashboardDesignerReducers.DashboardDesignerState) => {
      return state.loading;
    }
  );
}
